export default __webpack_public_path__ + "static/media/pdfChecked.b435995a.svg";